import './create.less';
import { actions, selectors } from './';
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Link } from 'react-router';
import renderViewsState from '../shared/render-views-state';
import Animate from '../shared/animation';

import EditForm from './components/form';
import TranslationsForm from './components/form-translations';

import { selectors as rootSelectors } from '../root';

const Main = renderViewsState(props => (
	<Animate>
		<div className="container__content payoutSystems-create">
			<div className="container__content-title clearfix">
				<div className="container__content-title-position">
					<Link to='payout-systems/' className="link">{ props.intl('Return to list of payout systems') }</Link>
				</div>
				<div className="container__content-title-position">
					<h2 className="title">{ props.intl('Edit payout system') }</h2>
				</div>
			</div>
			<div className="container__content-body">
				{props.langSwitchState.defaultLanguage === props.langSwitchState.currentLanguage ?
					<EditForm
						{...props} initialValues={props.getFieldsById(props.params.id)} editId={props.params.id}
					/>:
					<TranslationsForm
						{...props}
						enableReinitialize={true}
						initialValues={props.translationFormInitialValues}
						editId={props.params.id}
					/>
				}
			</div>
		</div>
	</Animate>
), 'view');

export default connect(
	state => ({
		data: selectors.getData(state),
		statusSelectOptions: selectors.getStatusSelectOptions(state),
		categorySelectOptions: selectors.getCategorySelectOptions(state),
		payoutSystemRegions: selectors.getPayoutSystemRegions(state),
		moduleSelectOptions: selectors.getModuleSelectOptions(state),
		currencySelectOptions: selectors.getCurrencySelectOptions(state),
		typeSelectOptions: selectors.getTypeSelectOptions(state),
		payoutFeeTypeOptions: selectors.getPayoutFeeTypeOptions(state),
		progressBar: selectors.getProgressBar(state),
		getFieldsById: selectors.getFieldsById(state),
		menuConfig: rootSelectors.getMenuConfig(state),
		translationFormInitialValues: selectors.getTranslationFormInitialValues(state),
		error: selectors.getError(state),
		mainTabLangs: selectors.getMainTabLangs(state),
		langSwitchState: selectors.getLangSwitchState(state),
		can: selectors.getCan(state),
		intl: selectors.getIntl(state)
	}),
	dispatch => bindActionCreators(actions, dispatch)
)(Main);



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payout-systems/edit.js